import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-019d93ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-0 mt-0" }
const _hoisted_2 = { class: "d-flex bg-white align-items-center w-100 top-navlink" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mt-4" }, null, -1))
const _hoisted_4 = { class: "pt-0 mt-0" }
const _hoisted_5 = { class: "d-flex bg-white align-items-center w-100 top-navlink" }
const _hoisted_6 = { class: "h5 d-none d-md-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mt-4" }, null, -1))
const _hoisted_8 = { class: "link_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showMiniSideBar)
      ? (_openBlock(), _createElementBlock("aside", {
          key: 0,
          class: _normalizeClass(["sidebar mini_sidebar", { expand: _ctx.showSideBar }])
        }, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", _hoisted_1, [
              _createElementVNode("li", _hoisted_2, [
                _createVNode(_component_Button, {
                  icon: "pi pi-bars",
                  class: "p-button-text d-none d-lg-block",
                  onClick: _withModifiers(_ctx.shorterSides, ["prevent"]),
                  "aria-label": "Toggle shorter sides"
                }, null, 8, ["onClick"])
              ]),
              _hoisted_3,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Navigation, (Nav) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: Nav.path,
                  class: "nav-item"
                }, [
                  _createVNode(_component_router_link, {
                    "exact-active-class": "active",
                    class: "nav-link",
                    to: Nav.path
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(Nav.icon)
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])), [
                  [
                    _directive_tooltip,
                    Nav.name.toUpperCase(),
                    void 0,
                    { right: true }
                  ]
                ])
              }), 128))
            ])
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("aside", {
          key: 1,
          class: _normalizeClass(["sidebar", { expand: _ctx.showSideBar }])
        }, [
          _createElementVNode("nav", null, [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _createVNode(_component_Button, {
                  icon: "pi pi-bars",
                  class: "p-button-text d-none d-lg-block",
                  onClick: _withModifiers(_ctx.shorterSides, ["prevent"]),
                  "aria-label": "Toggle shorter sides"
                }, null, 8, ["onClick"]),
                _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.accountType()), 1)
              ]),
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Navigation, (Nav) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: Nav.path,
                  class: "nav-item"
                }, [
                  _createVNode(_component_router_link, {
                    "exact-active-class": "active",
                    class: "nav-link",
                    to: Nav.path
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(Nav.icon)
                      }, null, 2),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(Nav.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ])
          ])
        ], 2))
  ]))
}